import { Button } from 'components/ui/Button/Button'
import { BodyText } from 'styling/Typography'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { IFoodHistoryDay } from 'types/foodLogistics/foodHistory.interface'
import { foodHistoryMock } from '../foodData'

const historyColumns: IHonestTableColumn<IFoodHistoryDay>[] = [
  {
    id: 'date',
    header: 'Date',
    sticky: true,
    minWidth: '8rem',
    cell: (r) => <BodyText weight='600'>{r.date}</BodyText>,
  },
  {
    id: 'status',
    header: 'Status',
    cell: (r) => (
      <StatusPill status={r.status === 'Finalized' ? 'success' : 'info'}>{r.status}</StatusPill>
    ),
  },
  { id: 'breakfast', header: 'Breakfast', cell: (r) => <BodyText>{r.breakfast}</BodyText> },
  { id: 'lunch', header: 'Lunch', cell: (r) => <BodyText>{r.lunch}</BodyText> },
  { id: 'dinner', header: 'Dinner', cell: (r) => <BodyText>{r.dinner}</BodyText> },
  { id: 'nightMeal', header: 'Night Meal', cell: (r) => <BodyText>{r.nightMeal}</BodyText> },
  { id: 'exceptions', header: 'Exceptions', cell: (r) => <BodyText>{r.exceptions}</BodyText> },
  { id: 'standbyUsed', header: 'Standby Used', cell: (r) => <BodyText>{r.standbyUsed}</BodyText> },
  {
    id: 'reversals',
    header: 'Reversals',
    cell: (r) =>
      r.reversals > 0 ? (
        <StatusPill status='accent'>{`${r.reversals} reversal`}</StatusPill>
      ) : (
        <BodyText>—</BodyText>
      ),
  },
  {
    id: 'drill',
    header: '',
    align: 'right',
    cell: () => (
      <Button variant='secondary' size='sm'>
        Per-kitchen drill-down
      </Button>
    ),
  },
]

export const HistoryTab = () => {
  return <HonestTable columns={historyColumns} data={foodHistoryMock} keyField='id' />
}
